module.exports = __webpack_public_path__ + "img/payment-error.5df387e7.png";